<script>
import appConfig from "@/app.config";
import { mapActions } from "vuex";
/**
 * Lock screen page -component
 */
export default {
  page: {
    title: "Lockscreen",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      unlockdata: {
        password: "",
      },
    };
  },
  methods: {
    ...mapActions({
      UnlockUser: "auth/UnclockScreen",
    }),
    Unclock() {
      this.UnlockUser(this.unlockdata);
    },
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <router-link tag="a" to="#" class="text-dark">
        <i class="mdi mdi-home-variant h2"></i>
      </router-link>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="card-body pt-0">
                <div>
                  <router-link tag="a" to="#">
                    <div class="row">
                      <div class="col-md-2">
                        <div class="avatar-md profile-user-wid mt-3">
                          <span class="avatar-title rounded-circle bg-light">
                            <img src="@/assets/images/logomain.png" alt height="40" />
                          </span>
                        </div>
                      </div>
                      <div class="col-md-10">
                        <div class="text-primary p-4">
                          <h4 class="text-primary">LOCKED</h4>
                          <p>Enter your cliniplus password to unlock.</p>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="p-2">
                  <form class="form-horizontal" @submit.prevent="Unclock()">
                    <div class="user-thumb text-center mb-4">
                      <img
                        src="@/assets/images/users/avatar-1.jpg"
                        class="rounded-circle img-thumbnail avatar-md"
                        alt="thumbnail"
                      />
                      <h5 class="font-size-15 mt-3">
                        {{ this.$store.getters["auth/usernames"] }}
                      </h5>
                    </div>

                    <div class="mb-3">
                      <label for="userpassword">Password</label>
                      <input
                        v-model="unlockdata.password"
                        type="password"
                        class="form-control"
                        id="userpassword"
                        placeholder="Enter password"
                      />
                    </div>

                    <div class="row mb-0">
                      <div class="col-12 text-end">
                        <button class="btn btn-primary w-md" type="submit">Unlock</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="mt-5 text-center">
              <p>
                © {{ new Date().getFullYear() }} Clinicplus. Developed
                <a target="_blank" href="#"> Nugsoft Technologies</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
